// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1djaU","header":"ReportDetails_header__xKUfv","title":"ReportDetails_title__2lKhH","left":"ReportDetails_left__1Cl-I"};